var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "post-sections"
  }, _vm._l(_vm.postSections, function (section, index) {
    return _c(_vm.getComponentName(section._type), {
      key: index,
      tag: "component",
      attrs: {
        sectionData: section
      }
    });
  }), 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };